<template lang="html">
  <div>
    <div class="row filters-style">
      <div class="col-xs-4">
        <pl-input
          style="width: 100%"
          v-model="course_search"
          placeholder="Search Courses"
          @keyup.enter="filters"
        />
      </div>
      <div class="teachers col-xs-3">
        <multiselect
          v-model="selected_teachers"
          :options="teachers"
          :multiple="true"
          :close-on-select="false"
          :clear-on-select="false"
          :preserve-search="true"
          placeholder="Teachers"
          label="name"
          track-by="id"
          :limit="1"
          :preselect-first="true"
          @input="filters"
          style="max-width: 100%"
        >
          <template slot="selection" slot-scope="{ values, search, isOpen }">
            <span
              class="multiselect__single"
              v-if="selected_teachers.length &amp;&amp; !isOpen"
            >
              {{ selected_teachers.length }} Teachers selected
            </span>
          </template>
          </multiselect>

        </pl-select>
      </div>
      <div class="col-xs-2 end-xs">
        <button
        class="px-8 py-2 rounded cursor-pointer bg-primary text-white text-sm font-semibold disabled:opacity-50"
        style="margin: 2px 0px"
        @click="goToAddCourses"
      >
        ADD COURSES
      </button>
        </div>
    </div>
  </div>
</template>

<script>
  import { EventBus } from 'utils/event-bus';
  import Multiselect from 'vue-multiselect';
  export default {
    components: {
      Multiselect,
    },
    data() {
      return {
        course_search: '',
        selected_teachers: [],
      };
    },
    props: {
      teachers: {
        type: Array,
        default(){
          return [];
        }
      }
    },
    methods: {
      goToAddCourses() {
        this.$router.push({ name: 'admin-add-courses' });
        EventBus.$emit('reloadAddCourses');
      },
      filters() {
        const filters = {
          course_title: this.course_search,
          user_ids: this.selected_teachers.map((teacher) => teacher.id),
        };
        this.$emit('admin-portal-filter-changed');
        this.$emit('filters', filters);
      },
    },
  };
</script>

<style lang="stylus" scoped>
  @import '~app/global-stylus.styl';

  .filters-style {
  }

  .filters-style div{
    display: inline-block;
  }

  .dialog-role-select{
    height: 40px;
    border: 2px solid #e1e8ee;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
  }
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
  .multiselect {
    .multiselect__content-wrapper {
      max-width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// topBar.vue?3b0947dc